import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';


import { CurrentLocaleCodeComponent } from './current-locale-code.component';

@NgModule({
  imports: [
    FormsModule,
    MaterialModule
  ],
  exports: [CurrentLocaleCodeComponent],
  declarations: [CurrentLocaleCodeComponent]
})
export class CurrentLocaleCodeModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/current-locale-code/current-locale-code.module.ts